/** Türkçe sözlük · hesaplar. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const hesaplar = {
  /** Hesap renkleri (`ui/HesapAdi.tsx`). */
  renk: {
    mavi: "Mavi",
    lacivert: "Lacivert",
    mor: "Mor",
    eflatun: "Eflatun",
    turkuaz: "Turkuaz",
    petrol: "Petrol",
    kahverengi: "Kahverengi",
    gri: "Gri",
  },

  /** `components/HesapSecici.tsx` */
  secici: {
    hesap: "Hesap",
    butunKasaGercek: "Bütün kasa (gerçek hesaplar)",
    hesaplar: "Hesaplar",
    sanalHesaplar: "Sanal hesaplar",
    sanalEk: (ad: string) => `${ad} (sanal)`,
    sanal: "(sanal)",
    butunKasa: "Bütün kasa",
    birHesap: "1 hesap",
    karsilastiriliyor: (n: number) => `${n} hesap karşılaştırılıyor`,
    aciklama: (enCok: number) =>
      `Hiçbiri işaretli değilse bütün kasa. İki ya da daha çok hesap işaretlenirse ayrı çizgilerle karşılaştırılır (en çok ${enCok}).`,
    kapat: "Kapat",
  },

  /** `screens/AccountsScreen.tsx` */
  ekran: {
    baslik: "Hesaplar",
    aciklama: "Hareketlerin bağlandığı kurum, banka ve cüzdanlar.",
    hesapEkle: "Hesap ekle",
    yeniHesap: "Yeni hesap",
    ucretsizSinir: (n: number) => `Ücretsiz kullanımda en çok ${n} etkin hesap.`,
    oksuzBaslik: "Silinmiş hesaplara bağlı hareketler var",
    oksuzMetin:
      "Bu hareketler hâlâ raporlara ve toplamlara giriyor. Her biri için hareketleri silebilir ya da başka bir hesaba taşıyabilirsiniz.",
    oksuzSatir: (n: number) => `(silinmiş hesap) — ${n} hareket`,
    coz: "Çöz…",
    yukleniyor: "Hesaplar yükleniyor…",
    bosBaslik: "Henüz hesap yok",
    bosYedekli:
      "Hareket girebilmek için önce en az bir hesap tanımlayın. Başka bir cihazda Parafon kullandıysanız kasanızı buluttan geri yükleyebilirsiniz.",
    bos: "Hareket girebilmek için önce en az bir hesap tanımlamanız gerekiyor.",
    ilkHesap: "İlk hesabı ekle",
    buluttanGeriYukle: "Buluttan geri yükle",
    tabloBaslik: "Tanımlı hesaplar",
    sutun: {
      ad: "Ad",
      tur: "Tür",
      kurum: "Kurum",
      paraBirimi: "Para birimi",
      acilis: "Açılış",
      kapanis: "Kapanış",
      islem: "İşlem",
    },
    devreDisi: "devre dışı",
    saltOkunur: "salt okunur",
    taninmayanKod: (kod: string) =>
      `"${kod}" tanınan bir para birimi kodu değil; bu hesaba bağlı hareketlerin kuru bulunamaz. Hesabı düzenleyip listeden bir kod seçin.`,
    tekrarAcIpucu: "Hesap ve hareketleri yeniden her yerde görünür.",
    devreDisiIpucu: "Hesap ve hareketleri bu sayfa dışında görünmez, toplamlara girmez. Silinmez.",
    tekrarAc: "Tekrar aç",
    devreDisiBirak: "Devre dışı bırak",
    hesabiDuzenle: "Hesabı düzenle",
    silBaslik: "Hesap silinsin mi?",
    silSonEk:
      " listeden kalkacak. Kayıt fiziksel olarak silinmez, silindi olarak işaretlenir (tombstone) — senkron katmanının silmeyi diğer cihazlara taşıyabilmesi için gerekli.",
    hareketYok: "Bu hesaba bağlı hareket yok.",
    tasiVeSil: "Taşı ve sil",
    cozBaslik: "Silinmiş hesabın hareketleri",
    cozSonEk: "hesabı silinmiş ama hareketleri duruyor.",
    tasi: "Taşı",
    hareketleriSil: "Hareketleri sil",
  },

  form: {
    adZorunlu: "Hesap adı zorunlu.",
    paraBirimiSecin: "Listeden bir para birimi seçin.",
    kapanisOnce: "Kapanış, açılıştan önce olamaz.",
    sinirDoldu: "Hesap sınırına ulaşıldı; yeni hesap Abonelik ile açılır.",
    hesapAdi: "Hesap adı",
    hesapTuru: "Hesap türü",
    kurum: "Kurum",
    kurumIpucu: "Aracı kurum ya da banka adı. Serbest metin.",
    anaParaBirimi: "Ana para birimi",
    paraBirimiIpucu: "Hareketler farklı para biriminde olabilir.",
    acilisTarihi: "Açılış tarihi",
    kapanisTarihi: "Kapanış tarihi",
    renk: "Renk",
    renkAciklama: "Hesabın adı bu renkte görünür. Tutarlar ve uyarılar boyanmaz.",
    hesapRengi: "Hesap rengi",
    renksiz: "Renksiz",
    not: "Not",
  },

  duzenlenebilir: {
    bolum: "Düzenlenebilir hesaplar",
    ne: (n: number) => `${n} hesaptan fazlasını düzenlemek`,
    aciklama: (n: number) =>
      `Hesaplarınız silinmedi ve raporlarda görünür; düzenlenebilir kalacak ${n} hesabı seçin, diğerleri salt okunur.`,
    secimiKaydet: "Seçimi kaydet",
  },
};
